import React, { useState, useEffect, useRef } from 'react';
import './Solutions-E-commerce.css';
import Header from '../Header/Header';
import Footer from '../footer/footer';
import { motion, AnimatePresence } from 'framer-motion';
import TopAnnouncementBar from '../TopAnnouncementBar/TopAnnouncementBar';
import WhatsAppButton from '../whatsapp/WhatsAppButton';
import { Link } from 'react-router-dom';
import { 
  FaRocket, 
  FaVideo, 
  FaFilm, 
  FaPlayCircle,
  FaArrowRight,
  FaCheckCircle,
  FaAward,
  FaClock,
  FaCode,
  FaUsers,
  FaShieldAlt,
  FaRegClock,
  FaRegEye,
  FaChartLine
} from 'react-icons/fa';
import { 
  SiAdobe,
  SiAdobepremierepro,
  SiAdobeaftereffects,
  SiDavinciresolve,
  SiFigma
} from 'react-icons/si';
import { MdAutoAwesome, MdOutlineSpeed, MdOutlineSecurity, MdAnalytics, MdVideoLibrary, MdEdit, MdAnimation, MdSlowMotionVideo } from 'react-icons/md';
import { GiAstronautHelmet, GiStarsStack, GiGalaxy, GiSpiralShell, GiCrystalBall, GiCyberEye, GiArtificialIntelligence, GiThunderSkull, GiBrain, GiRocketThruster, GiFilmProjector, GiClapperboard } from 'react-icons/gi';

const VideoMotion = () => {
  const [activeTab, setActiveTab] = useState(0);
  const [mousePosition, setMousePosition] = useState({ x: 0, y: 0 });
  const [isCursorActive, setIsCursorActive] = useState(false);
  const [scrollProgress, setScrollProgress] = useState(0);
  const sectionRef = useRef(null);
  let cursorTimeout;

  useEffect(() => {
    const handleMouseMove = (e) => {
      setMousePosition({ x: e.clientX, y: e.clientY });
      setIsCursorActive(true);
      
      clearTimeout(cursorTimeout);
      cursorTimeout = setTimeout(() => setIsCursorActive(false), 100);
    };
    
    const handleScroll = () => {
      if (sectionRef.current) {
        const rect = sectionRef.current.getBoundingClientRect();
        const scrollPercent = Math.min(1, Math.max(0, -rect.top / (rect.height - window.innerHeight)));
        setScrollProgress(scrollPercent);
      }
    };
    
    window.addEventListener('mousemove', handleMouseMove);
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('mousemove', handleMouseMove);
      window.removeEventListener('scroll', handleScroll);
      clearTimeout(cursorTimeout);
    };
  }, []);

  const solutionsData = [
    {
      title: "Montage Vidéo Professionnel",
      tagline: "Valorisez vos rushes",
      description: "On prend en charge le montage et la production vidéo pour que vos contenus soient percutants et prêts à être diffusés.",
      features: ["Montage sur-mesure", "Étalonnage couleur", "Sound design", "Effets visuels"],
      icon: <FaVideo />,
      color: "#3B82F6",
      stat: "4x plus d'engagement"
    },
    {
      title: "Reels & Shorts",
      tagline: "Viraux sur les réseaux",
      description: "Des formats courts et dynamiques optimisés pour TikTok, Instagram Reels et YouTube Shorts qui captent l'attention en 3 secondes.",
      features: ["Format vertical", "Sous-titres animés", "Transitions dynamiques", "Musique tendance"],
      icon: <FaPlayCircle />,
      color: "#10B981",
      stat: "+500% de vues"
    },
    {
      title: "Vidéos de Présentation",
      tagline: "Convertissez en 60 secondes",
      description: "Des vidéos corporate qui présentent votre entreprise, vos produits ou services avec un storytelling percutant.",
      features: ["Storytelling impactant", "Voix off professionnelle", "Motion graphics", "Call-to-action"],
      icon: <FaFilm />,
      color: "#8B5CF6",
      stat: "3x plus de conversions"
    },
    {
      title: "Motion Design",
      tagline: "L'art du mouvement",
      description: "Des animations graphiques sophistiquées pour expliquer des concepts complexes avec élégance et créativité.",
      features: ["Animation 2D/3D", "Kinetic typography", "Logo animation", "Infographies animées"],
      icon: <MdAnimation />,
      color: "#EC4899",
      stat: "+80% de mémorisation"
    }
  ];

  const benefits = [
    { icon: <FaRegClock />, title: "Gain de temps", description: "Vous fournissez les rushes, on s'occupe de tout", color: "#3B82F6" },
    { icon: <FaRegEye />, title: "Impact visuel", description: "Des vidéos qui captent l'attention", color: "#10B981" },
    { icon: <FaChartLine />, title: "Conversion optimisée", description: "Des vidéos pensées pour vendre", color: "#8B5CF6" },
    { icon: <GiClapperboard />, title: "Storytelling pro", description: "Un récit qui marque les esprits", color: "#F59E0B" },
    { icon: <MdSlowMotionVideo />, title: "Rythme maîtrisé", description: "Un montage au millimètre", color: "#EC4899" },
    { icon: <MdVideoLibrary />, title: "Multi-formats", description: "Adapté à tous les réseaux", color: "#06B6D4" }
  ];

  const statsData = [
    { value: "500+", label: "vidéos montées", icon: <FaVideo /> },
    { value: "100M+", label: "vues générées", icon: <FaRegEye /> },
    { value: "4.9/5", label: "satisfaction", icon: <FaAward /> },
    { value: "24h", label: "délai express", icon: <FaClock /> }
  ];

  const technologies = [
    { icon: <SiAdobepremierepro />, name: "Premiere Pro", color: "#9999FF" },
    { icon: <SiAdobeaftereffects />, name: "After Effects", color: "#9999FF" },
    { icon: <SiDavinciresolve />, name: "DaVinci Resolve", color: "#FF4A00" },
    { icon: <SiAdobe />, name: "Photoshop/Illustrator", color: "#FF0000" },
    { icon: <SiFigma />, name: "Figma", color: "#F24E1E" },
    { icon: <GiFilmProjector />, name: "Motion Design", color: "#3B82F6" }
  ];

  const getPreviewBadgeText = () => {
    switch(activeTab) {
      case 0: return "Montage professionnel";
      case 1: return "Format viral";
      case 2: return "Présentation impactante";
      case 3: return "Motion design créatif";
      default: return "Solution vidéo";
    }
  };

  return (
    <div className="vm-container" ref={sectionRef}>
      <WhatsAppButton />
      <TopAnnouncementBar />
      <Header />
      
      {/* Cursor Glow */}
      <motion.div 
        className={`vm-cursor-glow ${isCursorActive ? 'active' : ''}`}
        animate={{
          x: mousePosition.x - 300,
          y: mousePosition.y - 300,
        }}
        transition={{ type: "spring", damping: 30, stiffness: 200, mass: 0.5 }}
      />

      {/* Particles */}
      <div className="vm-particles">
        {[...Array(60)].map((_, i) => (
          <div key={i} className="vm-particle" style={{
            left: `${Math.random() * 100}%`,
            animationDelay: `${Math.random() * 20}s`,
            animationDuration: `${20 + Math.random() * 30}s`,
            width: `${1.5 + Math.random() * 3}px`,
            height: `${1.5 + Math.random() * 3}px`,
          }} />
        ))}
      </div>

      {/* Animated Orbs */}
      <div className="vm-orbs">
        <div className="vm-orb vm-orb-1" style={{ transform: `translate(${scrollProgress * 100}px, ${scrollProgress * 50}px)` }} />
        <div className="vm-orb vm-orb-2" style={{ transform: `translate(-${scrollProgress * 80}px, -${scrollProgress * 60}px)` }} />
        <div className="vm-orb vm-orb-3" style={{ transform: `translate(${scrollProgress * 60}px, -${scrollProgress * 40}px)` }} />
        <div className="vm-orb vm-orb-4" style={{ transform: `translate(-${scrollProgress * 70}px, ${scrollProgress * 70}px)` }} />
      </div>

      {/* Floating Elements */}
      <div className="vm-floating">
        <GiGalaxy className="vm-float vm-float-1" />
        <GiSpiralShell className="vm-float vm-float-2" />
        <GiAstronautHelmet className="vm-float vm-float-3" />
        <GiStarsStack className="vm-float vm-float-4" />
        <GiCrystalBall className="vm-float vm-float-5" />
        <GiCyberEye className="vm-float vm-float-6" />
        <GiArtificialIntelligence className="vm-float vm-float-7" />
        <GiThunderSkull className="vm-float vm-float-8" />
        <GiBrain className="vm-float vm-float-9" />
        <GiRocketThruster className="vm-float vm-float-10" />
        <GiFilmProjector className="vm-float vm-float-11" />
        <GiClapperboard className="vm-float vm-float-12" />
      </div>
      
      {/* ========== HERO BANNER ========== */}
      <section className="vm-hero">
        <div className="vm-hero-overlay"></div>
        <div className="vm-hero-inner">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="vm-hero-badge"
          >
            <GiClapperboard />
            <span>Video & Motion Excellence</span>
            <GiStarsStack />
          </motion.div>

          <motion.h1
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7, delay: 0.1 }}
            className="vm-hero-title"
          >
            Montage Vidéo & Motion Design<br />
            <span className="vm-gradient-text">qui captent l'attention</span>
          </motion.h1>

          <motion.p
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7, delay: 0.2 }}
            className="vm-hero-subtitle"
          >
            Vous avez du contenu vidéo brut mais pas les ressources pour le monter et le valoriser professionnellement.
            On prend en charge le montage et la production vidéo pour que vos contenus soient percutants et prêts à être diffusés.
          </motion.p>

          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7, delay: 0.3 }}
            className="vm-hero-buttons"
          >
            <Link to="/reservation-appel">
              <button className="vm-btn vm-btn-primary">
                <MdAutoAwesome /> Démarrer mon projet <FaArrowRight />
              </button>
            </Link>
            <Link to="/realisations">
              <button className="vm-btn vm-btn-secondary">
                <FaCode /> Voir nos créations
              </button>
            </Link>
          </motion.div>

          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.8, delay: 0.4 }}
            className="vm-hero-stats"
          >
            {statsData.map((stat, idx) => (
              <div key={idx} className="vm-stat-card">
                <div className="vm-stat-icon">{stat.icon}</div>
                <div className="vm-stat-value">{stat.value}</div>
                <div className="vm-stat-label">{stat.label}</div>
              </div>
            ))}
          </motion.div>
        </div>
      </section>

      {/* ========== BENEFITS SECTION ========== */}
      <section className="vm-benefits">
        <div className="vm-container-inner">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="vm-section-header"
          >
            <div className="vm-badge">Pourquoi nous</div>
            <h2>L'excellence <span className="vm-gradient-text">en production vidéo</span></h2>
            <p>Des vidéos professionnelles qui font la différence</p>
          </motion.div>

          <div className="vm-benefits-grid">
            {benefits.map((benefit, idx) => (
              <motion.div
                key={idx}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: idx * 0.05 }}
                whileHover={{ y: -8 }}
                className="vm-benefit-card"
                style={{ '--vm-card-color': benefit.color }}
              >
                <div className="vm-benefit-icon" style={{ color: benefit.color }}>{benefit.icon}</div>
                <h3>{benefit.title}</h3>
                <p>{benefit.description}</p>
                <div className="vm-benefit-glow" style={{ background: `radial-gradient(circle, ${benefit.color}20, transparent)` }} />
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* ========== SOLUTIONS SECTION - TABS ========== */}
      <section className="vm-solutions">
        <div className="vm-container-inner">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="vm-section-header"
          >
            <div className="vm-badge">Nos services</div>
            <h2>Services <span className="vm-gradient-text">vidéo & motion</span></h2>
            <p>Ce qu'on fait concrètement : Montage vidéo • Reels & Shorts • Vidéos de présentation • Motion design</p>
          </motion.div>

          {/* Tabs navigation */}
          <div className="vm-tabs-nav">
            {solutionsData.map((sol, idx) => (
              <button
                key={idx}
                className={`vm-tab-btn ${activeTab === idx ? 'active' : ''}`}
                onClick={() => setActiveTab(idx)}
                style={{ '--vm-tab-color': sol.color }}
              >
                <span className="vm-tab-icon">{sol.icon}</span>
                <span className="vm-tab-title">{sol.title}</span>
              </button>
            ))}
          </div>

          {/* Tab content */}
          <AnimatePresence mode="wait">
            <motion.div
              key={activeTab}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -20 }}
              transition={{ duration: 0.4 }}
              className="vm-tab-content"
            >
              <div className="vm-tab-left">
                <div className="vm-solution-tagline" style={{ color: solutionsData[activeTab].color }}>
                  {solutionsData[activeTab].tagline}
                </div>
                <h3>{solutionsData[activeTab].title}</h3>
                <p>{solutionsData[activeTab].description}</p>
                <div className="vm-features-list">
                  {solutionsData[activeTab].features.map((feat, i) => (
                    <div key={i} className="vm-feature-item">
                      <FaCheckCircle style={{ color: solutionsData[activeTab].color }} />
                      <span>{feat}</span>
                    </div>
                  ))}
                </div>
                <div className="vm-solution-stat" style={{ background: `${solutionsData[activeTab].color}15`, borderLeftColor: solutionsData[activeTab].color }}>
                  <FaRocket />
                  <span><strong>{solutionsData[activeTab].stat}</strong></span>
                </div>
              </div>
              <div className="vm-tab-right">
                <div className="vm-preview-card" style={{ background: `linear-gradient(135deg, ${solutionsData[activeTab].color}10, rgba(10,17,40,0.4))` }}>
                  <div className="vm-preview-icon" style={{ color: solutionsData[activeTab].color }}>
                    {solutionsData[activeTab].icon}
                  </div>
                  <div className="vm-preview-badge">
                    {getPreviewBadgeText()}
                  </div>
                  <div className="vm-preview-stats">
                    <span>🎬 Professionnel</span>
                    <span>⚡ Rapide</span>
                    <span>📱 Multi-format</span>
                  </div>
                </div>
              </div>
            </motion.div>
          </AnimatePresence>
        </div>
      </section>

      {/* ========== TECHNOLOGIES SECTION ========== */}
      <section className="vm-tech">
        <div className="vm-container-inner">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="vm-section-header"
          >
            <div className="vm-badge">Stack technique</div>
            <h2>Outils <span className="vm-gradient-text">professionnels</span></h2>
            <p>Nous utilisons les meilleurs logiciels du marché</p>
          </motion.div>

          <div className="vm-tech-grid">
            {technologies.map((tech, idx) => (
              <motion.div
                key={idx}
                initial={{ opacity: 0, scale: 0.9 }}
                whileInView={{ opacity: 1, scale: 1 }}
                viewport={{ once: true }}
                transition={{ delay: idx * 0.05 }}
                whileHover={{ y: -5 }}
                className="vm-tech-card"
              >
                <div className="vm-tech-icon" style={{ color: tech.color }}>{tech.icon}</div>
                <h4>{tech.name}</h4>
                <div className="vm-tech-bar">
                  <div className="vm-tech-progress" style={{ backgroundColor: tech.color }} />
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* ========== FINAL CTA ========== */}
      <section className="vm-final-cta">
        <div className="vm-cta-pattern"></div>
        <div className="vm-cta-inner">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="vm-cta-icon"
          >
            <GiRocketThruster />
          </motion.div>
          <motion.h2
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.1 }}
          >
            Prêt à <span className="vm-gradient-text">valoriser</span> votre contenu vidéo ?
          </motion.h2>
          <motion.p
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.2 }}
          >
            Confiez-nous vos rushes et obtenez des vidéos professionnelles prêtes à être diffusées.
          </motion.p>
          <Link to="/reservation-appel">
            <motion.button
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.98 }}
              className="vm-cta-button"
            >
              <MdAutoAwesome /> Demander un devis gratuit <FaArrowRight />
            </motion.button>
          </Link>
          <div className="vm-cta-features">
            <div><FaCheckCircle /> Réponse sous 24h</div>
            <div><FaShieldAlt /> Garantie satisfait</div>
            <div><FaUsers /> Support dédié</div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default VideoMotion;